import { createContext } from 'react';
export const defaultTileContext = {
  compact: false
};
export const TileContext = /*#__PURE__*/createContext(defaultTileContext);
const {
  Provider
} = TileContext;
export { Provider as TileContextProvider };